const Backbone = require('backbone');
const SquareFootCalculator = require('app/views/store/pages/products/square_foot_calculator');
const format = require('format');
require('store/global/pages/products/squarefootprice.dust');
var validator = window.BCOM.util.validator;
var _getDetails = function() {
	let packages = this.packages ? this.packages : '1',
		plural = packages > 1 ? 's' : '',
		squareFeet = this.squareFeet ? this.squareFeet : this.model.getSquareFeetPerCarton(),
		packagePrice = this.model.getPackaging();
	const packageName = packagePrice ? packagePrice.packagingDetails.name : 'Carton';
	return this.packages === 0 ? 'Enter square footage' : `${packages} ${packageName}${plural}, covers ${squareFeet} sq. ft.`;
};

var _enforceNumeric = function($input) {
	var value = $input.val();
	if (value && !validator.isNumeric(value) && value !== '') {
		$input.val(validator.whitelist(value, '0123456789'));
	}
};

var _handleInputChange = function() {
	var $input = this.$('#square-foot-text-input');
	_enforceNumeric($input);
	this.updateQuantity(parseInt($input.val(), 10) || 0);
};

module.exports = Backbone.View.extend({
	initialize: function() {
		this.squareFootCalculator = new SquareFootCalculator({
			model: this.model,
			el: '#square-foot-calculator'
		});

		this.listenTo(Backbone, 'squareFeet:updated', this.setQuantityFromCalculator, this);
		// Make sure we use the correct price when a different finish is selected.
		this.listenTo(Backbone, 'finish:clicked', this.finishUpdated, this);
		this.updateFromCalculator = false;
		this.packages = 0;
		this.squareFeet = this.model.getSquareFeetPerCarton();
		this.price = 0;
	},

	events: {
		'keyup #square-foot-text-input': _handleInputChange,
		'click #square-foot-text-input': _handleInputChange
	},

	finishUpdated: function() {
		if (this.model) {
			this.model._updatePrice();
			_handleInputChange.call(this);
		}
	},

	setQuantityFromCalculator: function(dimensions) {
		var total = Math.floor(dimensions.total);
		this.$('#square-foot-text-input').val(total !== 0 ? total : '');
		this.updateFromCalculator = true;
		this.updateQuantity(total || 0);
	},

	/**
	 * updateQuantity - Calculate # of cartons needed to meet user-specified
	 *   square footage, and update the quantity and price display accordingly.
	 */
	updateQuantity: function(squareFeet) {
		let packagesRequired, squareFeetCovered, totalPrice;
		const $cartButtonContainer = $('.js-sqft-add-to-cart-button-container'),
			$noTotalSquareFeet = $('.js-sqft-no-total-sqft'),
			$totalSquareFeet = $('.js-total-sq-ft');

		const currentSqFtPerPackaging = this.model.getSquareFeetPerCarton();
		packagesRequired = Math.ceil(squareFeet / currentSqFtPerPackaging);
		if (packagesRequired <= 0) {
			packagesRequired = 0;
		}

		squareFeetCovered = parseFloat((currentSqFtPerPackaging * packagesRequired).toFixed(2));
		totalPrice = packagesRequired * this.model.getCurrentPrice();
		this.model.set('quantity', packagesRequired || 1);

		// update product completeness
		if (packagesRequired > 0 && this.packages === 0) {
			Backbone.trigger('product:complete', {});
		} else if (packagesRequired === 0 && this.packages > 0) {
			Backbone.trigger('product:incomplete', {});
		}

		if (!this.updateFromCalculator && squareFeet !== this.squareFeetMeasurement) {
			this.squareFootCalculator.reset();
		}

		this.squareFeetMeasurement = squareFeet;
		this.updateFromCalculator = false;
		this.packages = packagesRequired;
		this.squareFeet = squareFeetCovered;
		this.price = totalPrice;
		this.render();
		if (squareFeet > 0) {
			$cartButtonContainer.removeClass('hidden');
			$noTotalSquareFeet.addClass('hidden');
			$totalSquareFeet.removeClass('error-highlight');
		} else {
			$cartButtonContainer.addClass('hidden');
			$noTotalSquareFeet.removeClass('hidden');
		}
	},

	render: function() {
		this.$('#sqft-info').html(_getDetails.call(this));
		this.$('.sqft-price').html(this.price ? format.currency(this.price) : '');
	}
});
